import { Component, OnInit } from "@angular/core";
import { EnvironmentConfig } from "../../core/core";

declare var environment: EnvironmentConfig;

@Component({
  selector: "common-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  environment: EnvironmentConfig = environment;
  footerItems: any;

  constructor() {}

  ngOnInit() {
    this.footerItems = [
      {
        text: "Renters",
        externalLink: "",
        submenu: [
          {
            text: "Rent machines",
            route: "/lp/rent-machines",
          },
          {
            text: "Getting started guide",
            externalLink: "https://support.rubbl.com/getting-started-guide-renters",
          },
          {
            text: "FAQs",
            externalLink: "https://support.rubbl.com/renters",
          },
          {
            text: "Rental Terms",
            route: "/help/rental-terms",
          },
          {
            text: "Cancellation Policy",
            externalLink: "https://support.rubbl.com/cancellation-policy-renters",
          },
        ],
      },
      {
        text: "Owners",
        externalLink: "",
        submenu: [
          {
            text: "Become an Owner",
            route: "/lp/list-your-machines",
          },
          {
            text: "List a Machine",
            route: "/owner/fleet/create",
          },
          // {
          //   text: "Earnings calculator",
          //   route: "/earnings-calculator",
          // },
          {
            text: "Getting started guide",
            externalLink: "https://support.rubbl.com/getting-started-guide-owners",
          },
          {
            text: "Insurance & protection",
            externalLink: "https://support.rubbl.com/insurance-protection",
          },
          {
            text: "FAQs",
            externalLink: "https://support.rubbl.com/owners",
          },
          {
            text: "Cancellation Policy",
            externalLink: "https://support.rubbl.com/cancellation-policy-owners",
          },
        ],
      },
      {
        text: "",
        images: [
          {
            externalLink: "https://www.facebook.com/rubblrentals",
            iconClass: `icon-facebook`,
          },
          {
            externalLink: "https://www.instagram.com/rubblrent/",
            iconClass: `icon-instagram`,
          },
          {
            externalLink: "https://www.linkedin.com/company/rubbl",
            iconClass: "icon-linkedin",
          },
          {
            externalLink: "https://www.youtube.com/channel/UCATIyKNqrItKQTLWZ9iN_OA",
            iconClass: "icon-youtube",
          },
        ],
        externalLink: "",
        submenu: [
          {
            text: "(866) 455-8531",
            externalLink: "tel:(866) 455-8531",
          },
          {
            text: "Terms of Service",
            externalLink: "https://company.rubbl.com/pubweb/market/Rubbl-TOS.pdf",
            targetBlank: true,
          },
          {
            text: "Privacy Policy",
            externalLink: "https://company.rubbl.com/pubweb/market/Rubbl-PP.pdf",
            targetBlank: true,
          },
          {
            text: "Careers",
            route: "/lp/careers",
          },
        ],
      },
      {
        text: "Categories",
        externalLink: "",
        submenu: [
          {
            text: "Excavators",
            route: ["/equipment-rentals/Excavator"],
          },
          {
            text: "Dozers",
            route: ["/equipment-rentals/Dozer"],
          },
          {
            text: "Loaders",
            route: ["/equipment-rentals/Loader"],
          },
          {
            text: "Skid Steers",
            route: ["/equipment-rentals/Skid Steer"],
          },
          {
            text: "Water Trucks",
            route: ["/equipment-rentals/Water Truck"],
          },
          {
            text: "Dump Trucks",
            route: ["/equipment-rentals/Dump Truck"],
          },
          {
            text: "Compactors",
            route: ["/equipment-rentals/Compactor"],
          },
          {
            text: "Motor Graders",
            route: ["/equipment-rentals/Motor Grader"],
          },
          {
            text: "Crawler Carriers",
            route: ["/equipment-rentals/Crawler Carrier"],
          },
        ],
      },
      // {
      //   text: "Makes",
      //   externalLink: "",
      //   submenu: [
      //     {
      //       text: "Caterpillar",
      //       route: ["/equipment-rentals/Caterpillar"],
      //     },
      //     {
      //       text: "John Deere",
      //       route: ["/equipment-rentals/John Deere"],
      //     },
      //     {
      //       text: "Bobcat",
      //       route: ["/equipment-rentals/Bobcat"],
      //     },
      //     {
      //       text: "Komatsu",
      //       route: ["/equipment-rentals/Komatsu"],
      //     },
      //     {
      //       text: "Kubota",
      //       route: ["/equipment-rentals/Kubota"],
      //     },
      //     {
      //       text: "Peterbilt",
      //       route: ["/equipment-rentals/Peterbilt"],
      //     },
      //     {
      //       text: "Volvo",
      //       route: ["/equipment-rentals/Volvo"],
      //     },
      //     {
      //       text: "JCB",
      //       route: ["/equipment-rentals/JCB"],
      //     },
      //     {
      //       text: "Hitachi",
      //       route: ["/equipment-rentals/Hitachi"],
      //     },
      //   ],
      // },
      {
        text: "Cities",
        externalLink: "",
        submenu: [
          {
            text: "Houston, TX",
            route: "/equipment-rentals/all/Houston-TX",
          },
          {
            text: "Denver, CO",
            route: "/equipment-rentals/all/Denver-CO",
          },
          {
            text: "Dallas, TX",
            route: "/equipment-rentals/all/Dallas-TX",
          },
          {
            text: "Albuquerque, NM",
            route: "/equipment-rentals/all/Albuquerque-NM",
          },
          {
            text: "Los Angeles, CA",
            route: "/equipment-rentals/all/Los-Angeles-CA",
          },
          {
            text: "Salt Lake City, UT",
            route: "/equipment-rentals/all/Salt-Lake-City-UT",
          },
          {
            text: "Dickinson, ND",
            route: "/equipment-rentals/all/Dickinson-ND",
          },
          {
            text: "Spokane, WA",
            route: "/equipment-rentals/all/Spokane-WA",
          },
          {
            text: "Lubbock, TX",
            route: "/equipment-rentals/all/Lubbock-TX",
          },
          {
            text: "Bassfield, MS",
            route: "/equipment-rentals/all/Bassfield-MS",
          },
          {
            text: "Billings, MT",
            route: "/equipment-rentals/all/Billings-MT",
          },
          {
            text: "Atlanta, GA",
            route: "/equipment-rentals/all/Atlanta-GA",
          },
        ],
      },
    ];
  }
}
